import React, { useState } from "react";
import { DURATION_UNITS, fromSeconds, toSeconds } from "../utility/duration";

// Value + unit picker. Takes and emits seconds (or "" when empty) so callers
// never deal with units.
function DeliveryTimeInput({ seconds, onChange, className = "" }) {
  const initial = fromSeconds(seconds);
  const [value, setValue] = useState(initial.value);
  const [unit, setUnit] = useState(initial.unit);

  const update = (nextValue, nextUnit) => {
    setValue(nextValue);
    setUnit(nextUnit);
    onChange(toSeconds(nextValue, nextUnit) ?? "");
  };

  return (
    <div className={`flex gap-2 ${className}`}>
      <input
        type="number"
        min="0"
        step="any"
        placeholder="e.g. 2"
        className="border-2 border-gray-300 p-2 rounded-md focus:border-teal-500 focus:outline-none w-full min-w-0"
        value={value}
        onChange={(e) => update(e.target.value, unit)}
      />
      <select
        className="border-2 border-gray-300 p-2 rounded-md focus:border-teal-500 focus:outline-none bg-white"
        value={unit}
        onChange={(e) => update(value, e.target.value)}
      >
        {DURATION_UNITS.map((u) => (
          <option key={u.value} value={u.value}>
            {u.label}
          </option>
        ))}
      </select>
    </div>
  );
}

export default DeliveryTimeInput;
